import { render, staticRenderFns } from "./SandboxBotMessage.vue?vue&type=template&id=327f2064&scoped=true&"
import script from "./SandboxBotMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./SandboxBotMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SandboxBotMessage.vue?vue&type=style&index=0&id=327f2064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327f2064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327f2064')) {
      api.createRecord('327f2064', component.options)
    } else {
      api.reload('327f2064', component.options)
    }
    module.hot.accept("./SandboxBotMessage.vue?vue&type=template&id=327f2064&scoped=true&", function () {
      api.rerender('327f2064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/sandbox/SandboxBotMessage.vue"
export default component.exports